import { MockedProvider, MockedProviderProps, MockedResponse } from '@apollo/client/testing';
import * as rtl from '@testing-library/react';
import * as React from 'react';
import _memoize from 'lodash/memoize';
import { ApolloCache } from '@apollo/client';
import { createMemoryHistory } from 'history';
import { Provider as ReduxProvider } from 'react-redux';
import createReduxStore from '../create-redux-store';
import { Router } from 'react-router';
import { ApplicationContext } from '../../common-context/src/application-context';
import { Permissions, Resources } from '@atlassian/cssxp-utils-generic';

const getStore = _memoize(() => createReduxStore());
const getHistory = _memoize(() => createMemoryHistory());

interface GraphWrapperProps {
  mockedProviderProps?: MockedProviderProps;
  mocks?: ReadonlyArray<MockedResponse>;
  cache?: ApolloCache<{}> | undefined;
}

interface RenderComponentProps {
  renderedComponent: JSX.Element;
  mocks?: ReadonlyArray<MockedResponse>;
  mockedProviderProps?: MockedProviderProps;
}

export const GraphWrapperForHook = ({ mockedProviderProps, children }: React.PropsWithChildren<GraphWrapperProps>) => (
  <MockedProvider {...mockedProviderProps} addTypename={mockedProviderProps?.addTypename ?? false}>
    <>{children}</>
  </MockedProvider>
);

export const renderComponentWithProviders = ({ renderedComponent, mockedProviderProps }: RenderComponentProps) => ({
  ...rtl.render(
    <MockedProvider {...mockedProviderProps} addTypename={mockedProviderProps?.addTypename ?? false}>
      <ApplicationContext.Provider
        /* @ts-ignore */
        value={{ permissions: [Permissions.TRANSACTION_ACCOUNT_WRITE], resources: [Resources.TRANSACTION_ACCOUNT] }}
      >
        {renderedComponent}
      </ApplicationContext.Provider>
    </MockedProvider>,
    {
      wrapper: TestingProviders,
    }
  ),
});

const TestingProviders = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <ReduxProvider store={getStore()}>
      <Router history={getHistory()}>{children}</Router>
    </ReduxProvider>
  );
};
